var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:[
      'dp-form',
      {
        'dp-form--condensed': _vm.condensed,
      }
    ],attrs:{"name":_vm.name},on:{"submit":function($event){$event.preventDefault();return (function (e) { return _vm.handleSubmit(e); }).apply(null, arguments)}}},[_vm._t("default"),_c('input',{staticClass:"dp-form__hidden-submit",attrs:{"type":"submit"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }